import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutGrid, Users, Calendar, Settings, ChevronDown } from 'lucide-react';
export function Sidebar() {
  const sidebarLinks = [{
    name: 'Overview',
    path: '/dashboard/overview',
    icon: LayoutGrid
  }, {
    name: 'Volunteers',
    path: '/dashboard/volunteers',
    icon: Users
  }, {
    name: 'Schedule',
    path: '/dashboard/schedule',
    icon: Calendar
  }, {
    name: 'Settings',
    path: '/dashboard/settings',
    icon: Settings
  }];
  return <aside className="w-64 border-r border-white/5 bg-[var(--bg)] flex flex-col shrink-0 hidden md:flex" data-id="element-47">
      <div className="p-6" data-id="element-48">
        <h3 className="text-xs font-semibold text-[var(--muted)] tracking-wider mb-3 uppercase" data-id="element-49">
          Active Event
        </h3>
        <button className="w-full flex items-center justify-between bg-[var(--surface)] hover:bg-[var(--surface-hover)] transition-colors border border-white/5 rounded-md px-3 py-2.5 text-sm" data-id="element-50">
          <span className="text-white font-medium" data-id="element-51">City Marathon 2026</span>
          <ChevronDown className="w-4 h-4 text-[var(--muted)]" data-id="element-52" />
        </button>
      </div>

      <nav className="flex-1 px-3 space-y-1" data-id="element-53">
        {sidebarLinks.map(link => <NavLink key={link.name} to={link.path} className={({
        isActive
      }) => `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${isActive ? 'text-[var(--accent)] bg-[var(--accent)]/10' : 'text-[var(--muted)] hover:text-white hover:bg-white/5'}`} data-id="element-54">
            <link.icon className="w-4 h-4" data-id="element-55" />
            {link.name}
          </NavLink>)}
      </nav>
    </aside>;
}